/**
 * `/` — the subscriber home.
 *
 * One `RouteObject`, so the file is `home.route.tsx` (singular). An aggregate
 * array would be `home.routes.tsx`, and the importer knows the shape from the
 * name.
 *
 * The route resolves nothing and fetches nothing: **no `loader` in this repo
 * performs a data read.** A fetching loader would create a cache TanStack
 * Query does not know about, and the two would drift on every mutation — a
 * class of bug that reproduces only on the second visit to a route. The page
 * component owns its reads.
 *
 * The chunk is split through the router's OWN `lazy`, not through
 * `React.lazy`: the data router awaits it before it renders the match, so the
 * feature needs no `Suspense` boundary of its own and never reaches back into
 * `src/router/` for a fallback it does not own.
 */
import type { RouteObject } from 'react-router-dom';

export const homeRoute: RouteObject = {
  index: true,
  lazy: async () => {
    const { HomePage } = await import('./HomePage');
    return { Component: HomePage };
  },
};
